module.exports = __webpack_public_path__ + "components/flag/static/square/hr-c7544a212a88ff6254a78b0810b0bca6.svg";